import { Route, Location } from "vue-router";
import { Localize } from "@/plugins/localization";
import store from "@/store";
import router from "@/router";

export const baseGuard = (_to: Route, _from: Route, next: Function) => {
  if (!store.getters["GET_CSRF_INFORMATION"].token) {
    store
      .dispatch("FETCH_CSRF_INFORMATION")
      .then(() => {
        return store.dispatch(
          "FETCH_USER_STATUS",
          store.getters["GET_CSRF_INFORMATION"].token
        );
      })
      .then(() => {
        next();
      })
      .catch(error => {
        console.error(error);
        store.dispatch("UPDATE_NOTIFICATION_STATUS", {
          status: true,
          component: "error"
        });
      });
  } else {
    next();
  }
};

export const registerGuard = (_to: Route, _from: Route, next: Function) => {
  if (store.getters["GET_USER_STATUS"].status) {
    store
      .dispatch("USER_LOGOUT", store.getters["GET_CSRF_INFORMATION"].token)
      .then(() => {
        return store.dispatch("FETCH_CSRF_INFORMATION");
      })
      .then(() => {
        next();
      })
      .catch(error => {
        console.error(error);
        store.dispatch("UPDATE_NOTIFICATION_STATUS", {
          status: true,
          component: "error"
        });
      });
  } else if (!store.getters["GET_CSRF_INFORMATION"].token) {
    store
      .dispatch("FETCH_CSRF_INFORMATION")
      .then(() => {
        return store.dispatch(
          "FETCH_USER_STATUS",
          store.getters["GET_CSRF_INFORMATION"].token
        );
      })
      .then(() => {
        next();
      })
      .catch(error => {
        console.error(error);
        store.dispatch("UPDATE_NOTIFICATION_STATUS", {
          status: true,
          component: "error"
        });
      });
  } else {
    next();
  }
};

export const resetPasswordGuard = (
  _to: Route,
  _from: Route,
  next: Function
) => {
  if (!store.getters["GET_CSRF_INFORMATION"].token) {
    store
      .dispatch("FETCH_CSRF_INFORMATION")
      .then(() => {
        return store.dispatch(
          "FETCH_USER_STATUS",
          store.getters["GET_CSRF_INFORMATION"].token
        );
      })
      .then(() => {
        if (store.getters["GET_USER_STATUS"].status) {
          store
            .dispatch(
              "USER_LOGOUT",
              store.getters["GET_CSRF_INFORMATION"].token
            )
            .then(() => {
              return store.dispatch("FETCH_CSRF_INFORMATION");
            })
            .then(() => {
              return store.dispatch(
                "FETCH_USER_STATUS",
                store.getters["GET_CSRF_INFORMATION"].token
              );
            })
            .then(() => {
              next();
            });
        } else {
          next();
        }
      })
      .catch(error => {
        console.error(error);
        store.dispatch("UPDATE_NOTIFICATION_STATUS", {
          status: true,
          component: "error"
        });
      });
  } else {
    next();
  }
};

export const localizationGuard = (to: Route) => {
  if (to.meta.requiresTranslation) {
    const translatedRoute = {} as Location;
    translatedRoute.path = `/${
      Localize.currentlocale
    }/${Localize.getRouteAliases(
      (to.name as string).toLocaleLowerCase(),
      true
    )}`;
    translatedRoute.query = to.query;
    if (translatedRoute.path !== to.path) {
      router.replace(translatedRoute);
    }
  }
};
